import { baseURL } from './baseUrl';

// Trade-account applicant endpoints (product-service, public / no auth):
//   GET  /accounts/exists/<email>  -> { user_exists: boolean }
//   POST /accounts/create/<email>  -> creates the Keycloak applicant (applicant
//        group, VERIFY_EMAIL + UPDATE_PASSWORD required actions) and emails the
//        activation link. 409 if the user already exists.
// The multi-step application form lives on the trade portal; this consumer page
// only captures an email and routes to trade login (exists) or activation (new).

export interface CheckAccountResult {
  exists: boolean;
}

export const apiCheckAccount = async (
  email: string
): Promise<CheckAccountResult> => {
  const response = await baseURL.get(
    `accounts/exists/${encodeURIComponent(email)}`
  );
  return { exists: Boolean(response.data?.user_exists) };
};

export const apiRequestApplicantActivation = async (
  email: string
): Promise<{ success: boolean; code: number; msg?: string }> => {
  const response = await baseURL.post(
    `accounts/create/${encodeURIComponent(email)}`
  );
  return response.data;
};
